export default __webpack_public_path__ + "static/saleslogobg-f311a96453450d3ba67c2cd5cdc8b437.png";